<template>
    <CCard>
        <CCardHeader>
            <strong>Платежи</strong>
        </CCardHeader>
        <CCardBody>
            <CDataTable
                hover
                :items="filteredItems"
                :fields="fields">
                <template #status="data">
                    <td>
                        <div
                            v-if="ozonPayLink(data.item)"
                            class="payment-ozon-status"
                        >
                            <CBadge color="info">&nbsp;Ссылка сформирована&nbsp;</CBadge>
                            <CButton
                                class="payment-ozon-copy"
                                size="sm"
                                color="info"
                                variant="outline"
                                @click.stop="copyPayLink(data.item)"
                            >
                                {{ copiedId === data.item.id ? 'Скопировано' : 'Скопировать' }}
                            </CButton>
                        </div>
                        <CBadge
                            v-else
                            :color="paymentStatusBagde(data.item.status)"
                        >&nbsp;{{ paymentStatusTitle(data.item.status) }}&nbsp;</CBadge>
                    </td>
                </template>
                <template #decline_reason="data">
                    <td class="payment-decline-cell">
                        <template v-if="data.item.decline">
                            <div class="payment-decline-reason">{{ data.item.decline.reason }}</div>
                        </template>
                        <span v-else-if="isUnsuccessfulPayment(data.item.status)">—</span>
                    </td>
                </template>
                <template #decline_payer="data">
                    <td class="payment-decline-cell">
                        <template v-if="data.item.decline">
                            {{ data.item.decline.payerMessage }}
                        </template>
                        <span v-else-if="isUnsuccessfulPayment(data.item.status)">—</span>
                    </td>
                </template>
                <template #price="data">
                    <td>
                        {{ data.item.price }}<span v-if="data.item.tips"> (чаевые)</span>
                    </td>
                </template>
                <template #created_at="data">
                    <td>
                        {{ formatDate(data.item.created_at) }}
                    </td>
                </template>
                <template #payment_card="data">
                    <td>
                        {{ paymentType(data.item) }}
                    </td>
                </template>
                <template #actions="data">
                    <td>
                        <CButton
                            @click="showDetailsDialog(data.item.id)"
                        ><CIcon
                            :content="$options.icons.cilInfo"
                        /></CButton>
                    </td>
                </template>
            </CDataTable>
        </CCardBody>

        <CModal
            title="Информация о платеже"
            color="info"
            :show.sync="showDetails"
            :footer="false"
            size="lg"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <CRow>
                        <CCol sm="4" class="form-group">ID</CCol>
                        <CCol sm="8" class="form-group">#{{ paymentDetails.id }}</CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="4" class="form-group">Заказ</CCol>
                        <CCol sm="8" class="form-group">#{{ paymentDetails.order_id }}</CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="4" class="form-group">Транзакция</CCol>
                        <CCol sm="8" class="form-group">{{ paymentDetails.transaction_id }}</CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="4" class="form-group">Сумма</CCol>
                        <CCol sm="8" class="form-group">{{ paymentDetails.price }}<span v-if="paymentDetails.tips"> (чаевые)</span></CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="4" class="form-group">Статус</CCol>
                        <CCol sm="8" class="form-group">
                            <div
                                v-if="ozonPayLink(paymentDetails)"
                                class="payment-ozon-status"
                            >
                                <CBadge color="info">&nbsp;Ссылка сформирована&nbsp;</CBadge>
                                <CButton
                                    class="payment-ozon-copy"
                                    size="sm"
                                    color="info"
                                    variant="outline"
                                    @click.stop="copyPayLink(paymentDetails)"
                                >
                                    {{ copiedId === paymentDetails.id ? 'Скопировано' : 'Скопировать' }}
                                </CButton>
                            </div>
                            <CBadge
                                v-else
                                :color="paymentStatusBagde(paymentDetails.status)"
                            >
                                &nbsp;{{ paymentStatusTitle(paymentDetails.status) }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <template v-if="paymentDetailsDeclineInfo">
                        <CRow>
                            <CCol sm="4" class="form-group">Причина отказа</CCol>
                            <CCol sm="8" class="form-group">
                                <div class="payment-decline-reason">{{ paymentDetailsDeclineInfo.reason }}</div>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="4" class="form-group">Сообщение для плательщика</CCol>
                            <CCol sm="8" class="form-group">{{ paymentDetailsDeclineInfo.payerMessage }}</CCol>
                        </CRow>
                    </template>
                    <CRow>
                        <CCol sm="4" class="form-group">Дата создания</CCol>
                        <CCol sm="8" class="form-group">{{ formatDate(paymentDetails.created_at) }}</CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="4" class="form-group">Дата изменения</CCol>
                        <CCol sm="8" class="form-group">{{ formatDate(paymentDetails.updated_at) }}</CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="4" class="form-group">Подробности</CCol>
                        <CCol sm="8" class="form-group"><pre>{{ paymentDetailsCode(paymentDetails.payload) }}</pre></CCol>
                    </CRow>
                </div>
                <div slot="footer"></div>
            </template>
        </CModal>
    </CCard>
</template>

<script>
    const {
        paymentStatusTitle,
        paymentStatusBagde,
    } = require('../../utils/order-views');
    const { ORDER_PAYMENT_STATUS } = require('../../utils/order');
    const { formatDate } = require('../../utils/views');
    import { cilInfo } from '@coreui/icons';

    export default {
        name: 'OrderPayments',

        props: {
            items: Array,
        },

        data() {
            return {
                isAuthorized: false,
                fields: [
                    { key: 'id', label: 'ID', _classes: 'font-weight-bold' },
                    { key: 'status', label: 'Статус' },
                    { key: 'decline_reason', label: 'Причина отказа' },
                    { key: 'decline_payer', label: 'Сообщение для плательщика' },
                    { key: 'price', label: 'Сумма' },
                    { key: 'created_at', label: 'Дата' },
                    { key: 'payment_card', label: 'Тип оплаты' },
                    { key: 'actions', label: 'Детали' },
                ],
                paymentDetails: {},
                showDetails: false,
                copiedId: null,
            };
        },

        computed: {
            filteredItems() {
                return !JSON.parse(localStorage.getItem('settings')).is_business_admin ? this.items : this.items.filter(item => { return !item.tips});
            },
            paymentDetailsDeclineInfo() {
                return this.paymentDetails.decline;
            },
        },

        watch: {},

        mounted() {
            
        },

        icons: {
            cilInfo,
        },

        methods: {
            showDetailsDialog(paymentId) {
                for (var i = 0; i < this.items.length; i++) {
                    if (paymentId === this.items[i].id) {
                        this.paymentDetails = this.items[i];
                    }
                }
                this.showDetails = true;
            },
            paymentStatusTitle(status) {
                return paymentStatusTitle(status);
            },
            paymentStatusBagde(status) {
                return paymentStatusBagde(status);
            },
            formatDate(date) {
                return formatDate(date);
            },
            parsePaymentPayload(payload) {
                if (!payload) {
                    return null;
                }
                if (typeof payload === 'object') {
                    return payload;
                }
                if (typeof payload !== 'string') {
                    return null;
                }
                try {
                    return JSON.parse(payload);
                } catch (err) {
                    return null;
                }
            },
            paymentType(data) {
                const parsed = this.parsePaymentPayload(data?.payload);
                if (!parsed || typeof parsed !== 'object') {
                    return '';
                }
                if (parsed.GatewayName === 'CompanyAccount') {
                    return 'Корпоративный счёт';
                }
                if (parsed.GatewayName === 'OzonBank' || parsed.GatewayName === 'OzonPay') {
                    return 'Ozon';
                }
                if (parsed.GatewayName) {
                    return parsed.GatewayName;
                }
                // Ozon Pay: нотификация (orderID/transactionID) или ответ createOrder (payLink)
                if (
                    parsed.orderID
                    || parsed.transactionID
                    || parsed.payLink
                    || parsed.item?.payLink
                    || (parsed.currencyCode && Array.isArray(parsed.items))
                ) {
                    return 'Ozon';
                }
                return '';
            },
            ozonPayLink(data) {
                if (!data || data.status !== ORDER_PAYMENT_STATUS.PROCESSING) {
                    return null;
                }
                const parsed = this.parsePaymentPayload(data.payload);
                if (!parsed || typeof parsed !== 'object') {
                    return null;
                }
                const link = parsed.payLink || parsed.PayLink || parsed.item?.payLink || parsed.item?.PayLink || null;
                return typeof link === 'string' && link ? link : null;
            },
            async copyPayLink(data) {
                const link = this.ozonPayLink(data);
                if (!link || !data || !data.id) {
                    return;
                }
                try {
                    if (navigator.clipboard && navigator.clipboard.writeText) {
                        await navigator.clipboard.writeText(link);
                    } else {
                        const input = document.createElement('textarea');
                        input.value = link;
                        input.setAttribute('readonly', '');
                        input.style.position = 'absolute';
                        input.style.left = '-9999px';
                        document.body.appendChild(input);
                        input.select();
                        document.execCommand('copy');
                        document.body.removeChild(input);
                    }
                    this.copiedId = data.id;
                    window.setTimeout(() => {
                        if (this.copiedId === data.id) {
                            this.copiedId = null;
                        }
                    }, 2000);
                } catch (copyError) {
                    this.$root.$emit('showError', 'Не удалось скопировать ссылку');
                }
            },
            isUnsuccessfulPayment(status) {
                return (
                    status === ORDER_PAYMENT_STATUS.FAIL
                    || status === ORDER_PAYMENT_STATUS.CANCELLED
                    || status === ORDER_PAYMENT_STATUS.NOT_FOUND
                );
            },
            paymentDetailsCode(details) {
                var code = '';
                if (details) {
                    try {
                        code = JSON.stringify(JSON.parse(details), null, 4);
                    } catch (err) {
                        // Nothing to do
                    }
                }
                return code;
            },
        },
    };
</script>

<style scoped>
.payment-decline-cell {
    max-width: 320px;
    vertical-align: top;
}

.payment-decline-reason {
    white-space: pre-line;
    color: #e55353;
    font-weight: bold;
}

.payment-ozon-status {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
}

.payment-ozon-copy {
    padding: 1px 8px;
    font-size: 11px;
    line-height: 1.3;
}
</style>